import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5c649682"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-4 mt-6 flex flex-col items-center text-center" }

import {
  onMounted,
} from 'vue';
import {
  ConversationSocketService,
  getConversationSocketService,
} from '@/services/ConversationSocketService';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'InstructionActions',
  setup(__props) {

let conversationSocketService: ConversationSocketService;

const conversationThreadStore = useStore.conversationThread;

function sendMessage(query: string): void {
  if (conversationThreadStore.isReplyLoading) {
    return;
  }

  conversationSocketService.sendMessage(query);
}

onMounted(() => {
  conversationSocketService = getConversationSocketService();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (sendMessage('List all products of the company')))
    }, " Learn about our products "),
    _createElementVNode("button", {
      type: "button",
      class: "btn",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (sendMessage('Provide info about the company')))
    }, " Know about our company "),
    _createElementVNode("button", {
      type: "button",
      class: "btn",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (sendMessage('How can I contact with company?')))
    }, " How can I contact you? ")
  ]))
}
}

})